import { h, render } from 'preact'
import { LogoApp } from './logo-app'

render(<LogoApp />, document.getElementById('logoApp'))
